import { useState } from 'react';
import Link from 'next/link';
import CustomImage from '@components/common/image';
import Text from '@components/common/text';
import Icon from '@components/common/assets';
import { useBookmarkStatus, useCompanyBookmarks } from '@repository/bookmark/useBookmark';
import { useAddCompanyLike, useDeleteCompanyLike } from '@repository/companies/useCompanies';
import { CompanyBookmarkDto } from '@domain/rs/bookmark/CompnayBookmarkRs';
import { FontStyle } from '@domain/constant/fontStyle';
import Colors from '@domain/constant/colors';
import { dummyImgSrc } from '@domain/constant/img/positionDummyImgSrc';
import { V2Route } from '@utils/routeUtil';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

const Empty = () => {
  return (
    <div className={cx('emptyWrapper')}>
      <Text fontStyle={FontStyle.B2_B}>북마크한 기업이 없습니다</Text>
    </div>
  );
};

interface ItemProps {
  data: CompanyBookmarkDto;
  onClick: (companySn: number, isLiked: boolean) => void;
}
const Item = ({ data, onClick }: ItemProps) => {
  const [isLiked, setIsLiked] = useState(data.likeYn);

  const handleBtn = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    onClick(data.companySn, isLiked);
    setIsLiked(!isLiked);
  };

  return (
    <Link className={cx('item')} href={V2Route.getCompanyChannelPage(data.companySn)}>
      <div className={cx('column1')}>
        <CustomImage
          className={cx('img')}
          src={data.logoImageUrl}
          alt={data.companyName}
          width={48}
          height={48}
          ErrorImage={
            <CustomImage className={cx('img')} src={dummyImgSrc} alt={data.companyName} width={48} height={48} />
          }
        />
        <div className={cx('textArea')}>
          <Text fontStyle={FontStyle.B2_B}>{data.companyName}</Text>
          <Text
            fontStyle={FontStyle.B3_M}
            color={Colors.C_COOL_GRAY_70}
          >{`${data.numberOfPositions}개 포지션 채용 중`}</Text>
        </div>
      </div>
      <button onClick={handleBtn}>
        {isLiked ? (
          <Icon name="heartLightFilled" width={32} height={32} />
        ) : (
          <Icon name="heartLight" width={32} height={32} />
        )}
      </button>
    </Link>
  );
};

const CompanyList = () => {
  const { data, isFetched } = useCompanyBookmarks();
  const { refetch } = useBookmarkStatus({ enabled: false });
  const { mutateAsync: addCompanyLike } = useAddCompanyLike(() => refetch());
  const { mutateAsync: deleteCompanyLike } = useDeleteCompanyLike(() => refetch());

  const handleLikedBtn = (companySn: number, isLiked: boolean) => {
    if (isLiked) {
      deleteCompanyLike(companySn);
    } else {
      addCompanyLike(companySn);
    }
  };

  if (isFetched && !data?.bookmarks.length) return <Empty />;
  const itemEls = data?.bookmarks.map((item) => <Item key={item.companySn} data={item} onClick={handleLikedBtn} />);

  return <div className={cx('wrapper')}>{itemEls}</div>;
};

export default CompanyList;
